export const ApiUrl = {
    login: "v1/Admin/login",
    addEditPrivacyPolicy: "v1/Admin/addEditPrivacyPolicy",
    addEditTermsAndCondtion: "v1/Admin/addEditTermsAndCondtion",
    list_policy: "v1/Admin/listPrivacyPolicy",
    listCompanies: "v1/Admin/listCompanies",
    managedCompanies: "v1/Admin/managedCompanies",
    listTermsAndCondtion: "v1/Admin/listTermsAndCondtion",

    addEditBroker: "v1/Admin/addEditBroker",
    addEditshipperReciever: "v1/Admin/addEditshipperReciever",
    addEditCustomer: "v1/Admin/addEditCustomer",
    listBroker: "v1/Admin/listBroker",
    listCustomer: "v1/Admin/listCustomer",
    listShipperReceiver: "v1/Admin/listShipperReceiver",
    brokerCsvUpload: "v1/Admin/brokerCsvUpload",
    customerCsvUpload: "v1/Admin/customerCsvUpload",
    shipperRecieverCsvUpload: "v1/Admin/shipperRecieverCsvUpload",
    deleteBroker: "v1/Admin/deleteBroker",
    deleteCustomer: "v1/Admin/deleteCustomer",
    deleteShipperReciever: "v1/Admin/deleteShipperReciever",
    fuleindex: "v1/Admin/fuleindex",
    list_fuleindex: "v1/Dashboard/fuleindexList",
    fileUpload: "v1/Open/fileUpload",
    addEditloads: "",
    listLoads: "v1/Admin/listLoads",
    addEditloadsdeleteData: "v1/Admin/deletingLoadAndReleasingDrivers",

    addEditMarketResearch: "v1/Admin/addEditMarketResearch",
    listMarketResearch: "v1/Admin/listMarketResearch",
    addEditNewRelease: "v1/Admin/addEditNewRelease",
    listNewRelease: "v1/Admin/listNewRelease",
    addEditPlans: "v1/Admin/addEditPlans",
    listPlans: "v1/Admin/listPlans",
    deletecomapnyAndItsUsers: "v1/Admin/deletecomapnyAndItsUsers",
    addEditIftaTaxrate: "v1/Admin/addEditIftaTaxrate",
    listIftaTaxrate: "v1/Admin/listIftaTaxrate",
    addEditIftaPayPerMilesTaxRate: "v1/Admin/addEditIftaPayPerMilesTaxRate",
    listIftaPayPerMilesTaxRate: "v1/Admin/listIftaPayPerMilesTaxRate",

    // Admin CRUD APIs
    createAdmin: "v1/Admin/createAdmin",
    listAdmins: "v1/Admin/getAdmins",
    listMainAdmins: "v1/Admin/getMainAdmins",
    getAdminById: "v1/Admin/getAdmin/:id",
    updateAdmin: "v1/Admin/updateAdmin/",
    deleteAdmin: "v1/Admin/deleteAdmin/",
    sendMail: "/v2/email/send-email",
    createVideo: "/v2/video/createVideo",
    updateVideo: "/v2/video/updateVideo/",
    listVideos: "/v2/video/getVideos",
    deleteVideos: "/v2/video/deleteVideo/",

    // Practice Documents
    createPracticeDocument: "/v2/practice-document/createPracticeDocument",
    updatePracticeDocument: "/v2/practice-document/updatePracticeDocument/",
    listPracticeDocuments: "/v2/practice-document/getPracticeDocuments",
    getPracticeDocument: "/v2/practice-document/getPracticeDocument/",
    deletePracticeDocument: "/v2/practice-document/deletePracticeDocument/",

    // Students
    createStudent: "/v2/student/createStudent",
    updateStudent: "/v2/student/updateStudent/", // append id when calling
    listStudents: "/v2/student/getStudents",
    getStudent: "/v2/student/getStudent/", // append id when calling
    deleteStudent: "/v2/student/deleteStudent/", // append id when calling

    getHiredEmployees: "/v2/employee/getHiredEmployees",
    updateEmployee: "/v2/employee/updateEmployee/",

    
    getHiredTeams: "/v2/team/getHiredTeams",
    updateTeam: "/v2/team/updateTeam/",

};
